import { httpGet, httpDelete, httpPost, httpPut } from './api.service';
import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { GetGeofenceRequest } from '../requestModels/getGeofenceRequest';
import { PaginatedResult } from '../types/PaginatedResult';
import { Geofence, GeofenceResponse } from '../types/Geofence';
import { ChangeLog } from '../types/ChangeLog';
import { SingleResult } from '../types/SingleResult';

const getGeofences = async (request: GetGeofenceRequest): Promise<SingleResult<PaginatedResult<GeofenceResponse>>> => {
  return await httpGet<SingleResult<PaginatedResult<GeofenceResponse>>>(`api/geofence`, request);
};

const addGeofences = async (request: Geofence): Promise<GeofenceResponse> => {
  return await httpPost<GeofenceResponse>(`api/geofence`, request);
};

const updateGeofences = async (request: Geofence): Promise<GeofenceResponse> => {
  return await httpPut<GeofenceResponse>(`api/geofence`, request);
};

const deleteGeofence = async (id: string): Promise<void> => {
  return await httpDelete(`api/geofence/${id}`);
};

const getGeofenceChangelog = async (id: string, request: PaginatedRequest): Promise<SingleResult<PaginatedResult<ChangeLog>>> => {
  return await httpGet<SingleResult<PaginatedResult<ChangeLog>>>(`api/geofence/${id}/changeLog`, request);
};

export { getGeofences, addGeofences, updateGeofences, deleteGeofence, getGeofenceChangelog };
